// Mapping der 10 Basissicherheit-Module zu Checklist-IDs
export const BASISSICHERHEIT_MODULES = {
    "Sichere Passwörter": { id: 3, category: "Authentifizierung" },
    "MFA": { id: 2, category: "Authentifizierung" },
    "Passwort-Manager": { id: 1, category: "Authentifizierung" },
    "Ad-Blocker": { id: 7, category: "Web-Browsing" },
    "App-Berechtigungen": { id: 26, category: "Mobile Geräte" },
    "Automatische Updates": { id: 27, category: "Mobile Geräte" },
    "Router Passwort ändern": { id: 21, category: "Netzwerke" },
    "Email Account absichern": { id: 11, category: "E-Mail" },
    "Social Media": { id: 18, category: "Soziale Medien" },
    "Backups": { id: 32, category: "Persönliche Computer" }
  };
  
  // Typ-spezifische Inhalte für Quiz-Ergebnisse - 6 Gruppen
  export const LEARNING_GROUPS = {
    "Der sichere Begleiter": {
      milieus: ["Traditionell"],
      heroTitle: "Die sichere Begleiterin / Der sichere Begleiter",
      heroSubline: "Klare Regeln und verlässliche Routinen geben dir Sicherheit – du willst wissen, was immer gilt.",
      profileDescription: "Du schätzt Ordnung, klare Zuständigkeiten und bewährte Abläufe – Sicherheit entsteht für dich durch Konsequenz. Dein Stolperstein: Neue Methoden oder Tools wirken schnell unnötig kompliziert.",
      quickWins: [
        "Sichere Grundlagen",
        "Vorsichtige Datenfreigabe",
        "Bewährte Methoden"
      ],
      learningStyle: "Schritt für Schritt",
      motivation: "Verlässlichkeit im Alltag",
      strength: [
        "Hohe Regel- und Ordnungstreue",
        "Konsequenz in wiederkehrenden Sicherheitsroutinen",
        "Sparsam/umsichtig: vermeidet unnötige Datenverteilung"
      ],
      attention: [
        "Geringes Vertrauen in neue digitale Verfahren → Umgehung/Vermeidung",
        "Phishing durch „amtlich“ wirkende Mails/Briefe besonders wirksam",
        "Passwort-Wiederverwendung/Notizzettel aus Sicherheitsbedürfnis"
      ],
      recommendedModules: [
        {
          title: "Sichere Passwörter",
          duration: "4 Min",
          why: "Vorsichtige, fundierte Einführung",
          moduleName: "Sichere Passwörter"
        },
        {
          title: "MFA",
          duration: "4 Min",
          why: "Schritt-für-Schritt Anleitung",
          moduleName: "MFA"
        },
        {
          title: "Passwort-Manager",
          duration: "5 Min",
          why: "Praktische Einrichtung für verlässliche Routinen",
          moduleName: "Passwort-Manager"
        }
      ]
    },
    "Der vertrauensvolle Navigator": {
      milieus: ["Konservativ‑Gehoben"],
      heroTitle: "Die vertrauensvolle Navigatorin / Der vertrauensvolle Navigator",
      heroSubline: "Du willst Überblick und Diskretion – Sicherheit schützt Vertrauen, Reputation und Handlungsfähigkeit.",
      profileDescription: "Du sorgst dafür, dass Standards eingehalten werden und Verlässlichkeit zählt – Informationssicherheit ist für dich Teil von Professionalität und Reputation. Achte nur darauf, dass Tempo und pragmatische Ausnahmen nicht komplett ausgebremst werden.",
      quickWins: [
        "Phishing in 10 Sekunden prüfen",
        "MFA richtig nutzen",
        "Daten sicher teilen"
      ],
      learningStyle: "Kurz & entscheidungsorientiert",
      motivation: "Verantwortung",
      strength: [
        "Hohe Regel- und Verantwortungsorientierung",
        "Risikobewusstsein & Sorgfalt bei sensiblen Informationen",
        "Qualitätsanspruch: saubere Prozesse statt Improvisation"
      ],
      attention: [
        "Zu langsames Handeln/Eskalieren bei Security-Vorfällen",
        "Übermäßige Bürokratie bremst pragmatische Schutzmaßnahmen",
        "„Das ist geregelt“ – blinder Fleck für neue Angriffsarten"
      ],
      recommendedModules: [
        {
          title: "Sichere Passwörter",
          duration: "4 Min",
          why: "Klare Regeln für maximale Sicherheit",
          moduleName: "Sichere Passwörter"
        },
        {
          title: "MFA",
          duration: "4 Min",
          why: "Schritt-für-Schritt Anleitung für maximale Sicherheit",
          moduleName: "MFA"
        },
        {
          title: "Passwort-Manager",
          duration: "5 Min",
          why: "Praktische Einrichtung für verlässliche Routinen",
          moduleName: "Passwort-Manager"
        }
      ]
    },
    "Der effiziente Macher": {
      milieus: ["Performer", "Adaptiv‑Pragmatische Mitte", "Expeditiv"],
      heroTitle: "Die effiziente Macherin / Der effiziente Macher",
      heroSubline: "Du setzt auf Tools und Systeme, die dir Zeit sparen und Sicherheit maximieren.",
      profileDescription: "Du willst praktikable Lösungen, die sich sofort anwenden lassen – ohne viel Theorie. Dein Stolperstein: \"passt schon\"-Entscheidungen bei Mails, Links und schnellen Freigaben.",
      quickWins: [
        "2FA schnell einrichten",
        "Passwort-Manager automatisieren",
        "Sicherheits-Checklisten nutzen"
      ],
      learningStyle: "effizient & toolbasiert, Quick Wins",
      motivation: "Zeitersparnis & Effizienz",
      strength: [
        "Pragmatische Problemlösung (macht’s sofort umsetzbar)",
        "Schnelle Umsetzung von Best Practices bei klarem Nutzen",
        "Gutes Gespür für alltagstaugliche Standards im Team"
      ], 
      attention: [
        "„Passt schon“-Klicks bei Links/Anhängen/QR-Codes",
        "Zu breite Freigaben (Cloud-Link „jeder mit Link“)",
        "Updates/MFA/Password-Manager nicht konsequent auf allen Accounts"
      ],
      recommendedModules: [
        {
          title: "Sichere Passwörter",
          duration: "4 Min",
          why: "Grundlage für effiziente Sicherheit",
          moduleName: "Sichere Passwörter"
        },
        {
          title: "MFA",
          duration: "3 Min",
          why: "Zeitsparende Automatisierung",
          moduleName: "MFA"
        },
        {
          title: "Passwort-Manager",
          duration: "4 Min",
          why: "Schnelle Integration in deinen Workflow",
          moduleName: "Passwort-Manager"
        }
      ]
    },
    "Der verantwortliche Gestalter": {
      milieus: ["Neo‑Ökologisch", "Postmateriell"],
      heroTitle: "Die verantwortliche Gestalterin / Der verantwortliche Gestalter",
      heroSubline: "Du denkst kritisch und verantwortungsvoll – so schützt du dich und andere nachhaltig.",
      profileDescription: "Du denkst Sicherheit vom Menschen her: Datenschutz, Fairness und verantwortungsvoller Umgang mit Informationen sind für dich zentral. Achte darauf, dass moralische Empörung nicht den Blick für konkrete Schritte ersetzt.",
      quickWins: [
        "Phishing-Muster verstehen",
        "Datenminimierung praktizieren",
        "Quellen prüfen"
      ],
      learningStyle: "tief & fundiert mit Praxisbezug",
      motivation: "Verantwortung & Transparenz",
      strength: [
        "Hohe Sensibilität für Schutz von Menschen & Daten",
        "Aufmerksamkeit für Missbrauch/Manipulation (Social Engineering)",
        "Mut zum Ansprechen von Risiken (Hinweisgeber-Mindset)"
      ],
      attention: [
        "Moralische Bewertung ersetzt manchmal konkrete Sofortschritte",
        "„Gute Zwecke“-Bias: zu viel Vertrauen in sympathische Absender",
        "Ausweich-Tools/Shadow-IT, wenn offizielle Tools als „falsch“ wirken"
      ],
      recommendedModules: [
        {
          title: "Sichere Passwörter",
          duration: "4 Min",
          why: "Fundierte Grundlagen für verantwortungsvolle Sicherheit",
          moduleName: "Sichere Passwörter"
        },
        {
          title: "MFA",
          duration: "4 Min",
          why: "Tiefes Verständnis der Sicherheitsmechanismen",
          moduleName: "MFA"
        },
        {
          title: "Passwort-Manager",
          duration: "5 Min",
          why: "Verantwortungsvoller und nachhaltiger Umgang mit Passwörtern",
          moduleName: "Passwort-Manager"
        }
      ]
    },
    "Der schnelle Checker": {
      milieus: ["Konsum‑Hedonistisch"],
      heroTitle: "Die schnelle Checkerin / Der schnelle Checker",
      heroSubline: "Kurz, smart, direkt anwendbar – du willst Tricks, die sofort wirken.",
      profileDescription: "Du willst's unkompliziert, unterhaltsam und ohne großen Regelballast – wenn etwas sofort Nutzen bringt, machst du mit. Dein Stolperstein: \"Wird schon passen\"-Klicks bei Gewinnspielen, Links, QR-Codes oder spontanen App-/Tool-Installationen, vor allem unterwegs und unter Zeitdruck.",
      quickWins: [
        "Spaßige Sicherheits-Apps",
        "Gamification nutzen",
        "Unterhaltsame Lernwege"
      ],
      learningStyle: "kurz, spielerisch & unterhaltsam",
      motivation: "Sofortiger Nutzen",
      strength: [
        "Hohe Reaktionsbereitschaft bei spielerischen, kurzen Formaten",
        "Lernt gut über Beispiele/Aha-Momente statt Theorie",
        "Social Awareness: erkennt Auffälligkeiten, wenn „Red Flags“ klar sind"
      ],
      attention: [
        "Impulsives Klicken (Gewinnspiele, Liefer-SMS, QR-Codes, Social Ads)",
        "Bequemlichkeit bei Passwörtern/MFA („später“) und App-Rechten",
        "Unterwegs-Risiken: öffentliches WLAN, Bluetooth/AirDrop, Screen-Privacy"
      ],
      recommendedModules: [
        {
          title: "Sichere Passwörter",
          duration: "4 Min",
          why: "Schnell und direkt anwendbar",
          moduleName: "Sichere Passwörter"
        },
        {
          title: "MFA",
          duration: "4 Min",
          why: "Sofortiger Nutzen und spielerische Einrichtung",
          moduleName: "MFA"
        },
        {
          title: "Passwort-Manager",
          duration: "5 Min",
          why: "Moderne, benutzerfreundliche Tools",
          moduleName: "Passwort-Manager"
        }
      ]
    },
    "Der bodenständige Helfer": {
      milieus: ["Prekär"],
      heroTitle: "Die bodenständige Helferin / Der bodenständige Helfer",
      heroSubline: "Du willst Klarheit und Unterstützung – Schritt für Schritt, ohne Angst vor Fehlern.",
      profileDescription: "Du willst Dinge richtig machen und dazugehören – am besten ohne Stress und ohne Fachchinesisch. Dein Risiko: bei Überforderung wird abgebrochen oder aus Unsicherheit geklickt, statt nachzufragen.",
      quickWins: [
        "Kostenlose Sicherheits-Tools",
        "Einfache Passwort-Regeln",
        "Schnelle 2FA-Einrichtung"
      ],
      learningStyle: "einfach & geführt",
      motivation: "Sicherheit im Alltag",
      strength: [
        "Hohe Lernbereitschaft bei niedrigschwelliger Unterstützung",
        "Praktisch orientiert: macht mit, wenn es sofort hilft",
        "Loyal, wenn Zugehörigkeit/Respekt spürbar ist"
      ],
      attention: [
        "Überforderung → vorschnelles Klicken statt Nachfragen",
        "Scham/Angst verhindert frühes Melden von Fehlern/Vorfällen",
        "Geräte-/Account-Sharing & unsichere Workarounds aus Alltagdruck"
      ],
      recommendedModules: [
        {
          title: "Sichere Passwörter",
          duration: "4 Min",
          why: "Einfache, kostenlose Grundlagen",
          moduleName: "Sichere Passwörter"
        },
        {
          title: "MFA",
          duration: "4 Min",
          why: "Schnelle, kostenlose Einrichtung",
          moduleName: "MFA"
        },
        {
          title: "Passwort-Manager",
          duration: "5 Min",
          why: "Praktische, kostenlose Lösungen",
          moduleName: "Passwort-Manager"
        }
      ]
    }
  };
  
  // Mapping von Milieu-Namen zu Gruppen
  export const getGroupForMilieu = (milieuName) => {
    for (const [groupName, groupData] of Object.entries(LEARNING_GROUPS)) {
      if (groupData.milieus.includes(milieuName)) {
        return groupName;
      }
    }
    // Fallback
    return "Der vertrauensvolle Navigator";
  };
  
  // Legacy: Für Rückwärtskompatibilität
  export const MILIEU_PROFILES = LEARNING_GROUPS;
  